export const LANE_COUNT = 5;
export const LANE_WIDTH = 2.2;
export const LANE_POSITIONS = [-4.4, -2.2, 0, 2.2, 4.4] as const;

export const RUNNER = {
  baseSpeed: 14,
  maxSpeed: 28,
  jumpVelocity: 9.5,
  gravity: 16,
  slideDurationMs: 700,
  invulnerableMs: 900,
  startingHearts: 3,
} as const;

export const SRS_INTERVALS_MS = [
  60_000, // 1 min — just learned
  10 * 60_000, // 10 min
  60 * 60_000, // 1 hour
  24 * 3600_000, // 1 day
  3 * 24 * 3600_000, // 3 days
  7 * 24 * 3600_000, // 1 week
  30 * 24 * 3600_000, // 1 month
] as const;

export const PIN_LENGTH = 4;
export const CLASS_CODE_LENGTH = 6;

export const SESSION_COOKIE = "wr_session";
export const SESSION_TTL_SECONDS = 60 * 60 * 24 * 30; // 30 days
